import React, { Component } from 'react'
import Clock from '../Common/Clock'

class ClockComponent extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.handlePageClick()
  }

  render() {
    return (
      <div
        style={{
          color: '#FFFFFF',
          fontSize: '45px',
          textAlign: 'center',
          letterSpacing: '10px',
          cursor: 'grab',
          paddingTop: '150px'
        }}
        onClick={this.handleClick}>
        <img src={require('../../images/cloudRiches_logo_white.png')} style={{ height: '100px' }} alt="" />
        <Clock type="time" />
      </div>
    )
  }
}

export default ClockComponent



// WEBPACK FOOTER //
// ./src/components/LoginPage/ClockComponent.js